import { ExternalBridgeType } from '@types';
import { FC, useEffect, useMemo } from 'react';
import Icon from './Icon';
import Button from './Button';
import { EXTERNAL_BRIDGES } from './ExternalBridgesInfo/config';
import useGenericPopup from '@hooks/useGenericPopup';

const ExternalBridgeLinkContent: FC<{ type: ExternalBridgeType }> = ({
  type,
}) => {
  const bridge = useMemo(
    () => EXTERNAL_BRIDGES.find((bridge) => bridge.type === type),
    [type]
  );
  const { showPopup } = useGenericPopup();

  useEffect(() => {
    if (!bridge) {
      showPopup({
        header: 'Bridge not found',
        body: 'The bridge you are looking for is not available',
      });
    }
  }, [bridge, showPopup]);

  if (!bridge) return null;

  return (
    <div className="text-center text-white text-[14px]">
      <div className="flex items-center justify-center gap-0.5">
        <Icon.WarningTriangle />
        <div className="text-[#FA3952] text-[16px] font-bold">NOTE</div>
      </div>
      <div>
        I understand using 3rd party applications and interacting with them
        carries risks.
      </div>
      <div>
        Please DYOR and do not engage in activities you are unfamiliar with.
      </div>
      <a href={bridge.link} target="_blank" rel="noopener noreferrer">
        <Button className="w-full mt-6">Take me to {bridge.name}</Button>
      </a>
    </div>
  );
};

export default ExternalBridgeLinkContent;
